import React from "react";
import {Stack, Typography} from "@mui/material";
import SearchOffIcon from '@mui/icons-material/SearchOff';
import {useTranslation} from "react-i18next";

export default function NoResult() {
    const {t} = useTranslation("common");
    return (
        <Stack alignItems="center" justifyContent="center" m={4}>
            <SearchOffIcon sx={{fontSize: 60}}/>
            <Typography variant="h6">{t("main.components.search.noResult")}</Typography>
        </Stack>
    )
}